import Vue from 'vue'
import Cookies from 'cookies-js'

Vue.directive('organization', {
  bind: function (el, { value, rawName, expression, arg }) {
    el.addEventListener('click', e => {
      Cookies.set('organization_type', value)
    })
  }
})
